var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.642822,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#373F47"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3508_7159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3558 8.47872C18.4824 7.00717 20.0487 7 20.0487 7C20.0487 7 20.2817 8.3835 19.1625 9.71626C17.9674 11.1393 16.609 10.9065 16.609 10.9065C16.609 10.9065 16.3539 9.78727 17.3558 8.47872ZM16.7523 11.8756C17.3319 11.8756 18.4076 11.0861 19.8078 11.0861C22.218 11.0861 23.1661 12.7856 23.1661 12.7856C23.1661 12.7856 21.3117 13.7252 21.3117 16.005C21.3117 18.5769 23.6218 19.4632 23.6218 19.4632C23.6218 19.4632 22.007 23.9675 19.8257 23.9675C18.8239 23.9675 18.045 23.2984 16.9894 23.2984C15.9137 23.2984 14.8462 23.9924 14.151 23.9924C12.1592 23.9925 9.64282 19.7197 9.64282 16.2852C9.64282 12.9061 11.7727 11.1334 13.7705 11.1334C15.0692 11.1334 16.0771 11.8756 16.7523 11.8756Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3508_7159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 17,
    fill: "white",
    transform: "translate(9.64282 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/iconApple.2d606506ae05256093864934c66ffcd8.svg";
export { ForwardRef as ReactComponent };